import { useGame } from '../state/GameProvider';

export function DebugPanel() {
  const { state, debug } = useGame();
  if (!debug) return null;

  const last = state.errors[state.errors.length - 1];
  const show = !state.connected || state.errors.length > 0 || debug.readyStateLabel === 'CONNECT_FAILED';

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'rgba(20,20,20,0.96)',
        color: '#f1f1f1',
        fontFamily: 'ui-monospace, SFMono-Regular, monospace',
        fontSize: 12,
        padding: '10px 14px',
        borderTop: '2px solid #b91c1c',
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 4 }}>Diagnóstico de conexión</div>
      <div>URL: <span style={{ color: '#67e8f9' }}>{debug.url || '(no conectado)'}</span></div>
      <div>Estado WS: <b>{debug.readyStateLabel}</b></div>
      <div>Cerrado con código: <b>{debug.closedCode ?? '-'}</b> reason: <b>{debug.closedReason ?? '-'}</b></div>
      <div>Sesión: {state.session ? `${state.session.code} status=${state.session.status}` : '(sin sesión)'}</div>
      {last && (
        <div style={{ marginTop: 6 }}>
          Último error: <span style={{ color: '#fca5a5' }}>{last.code}</span> — {last.message}
        </div>
      )}
      {state.errors.length > 1 && (
        <details style={{ marginTop: 6 }}>
          <summary>Todos los errores ({state.errors.length})</summary>
          <ul style={{ paddingLeft: 18, margin: '6px 0' }}>
            {state.errors.map((e, i) => (
              <li key={i}>
                <span style={{ color: '#fca5a5' }}>{e.code}</span> — {e.message}
              </li>
            ))}
          </ul>
        </details>
      )}
      <div style={{ marginTop: 6, color: '#9ca3af' }}>
        Si esto no se mueve al recargar, abre DevTools → Console y pega los logs con prefijo <code>[ws]</code>.
      </div>
    </div>
  );
}
